import { getGoogleLocationAddress }    from './display_helpers';
import { getGoogleLocationIsVerified } from './display_helpers';
import { isServiceAreaLocation }       from './display_helpers';
import Alert                           from '../../components/alert';
import ConfirmButton                   from '../../components/confirm_button';
import Link                            from '../../components/link';
import React                           from 'react';


export default function CurrentLocation({ businessID, business, googleLocation, disconnectLocation }) {
  const status       = business.google.status;
  const isAuthorized = (status !== 403);

  return (
    <div className="google-location">
      <LocationInfo {...{ googleLocation, isAuthorized }}/>
      <div className="block inset">
        {isAuthorized && <VerifyLocationButton {...{ businessID, googleLocation }}/>}
        {!isAuthorized && <ReconnectLocationButton {...{ businessID }}/>}
        <DisconnectLocationButton {...{ googleLocation, disconnectLocation }}/>
      </div>
    </div>
  );
}


function LocationInfo({ googleLocation, isAuthorized }) {
  const { locationName } = googleLocation;
  const address          = getGoogleLocationAddress(googleLocation);
  const title            = isAuthorized ? 'Connected' : 'Authentication Error';

  return (
    <div className="block list inset">
      <h3>{title}</h3>
      {!isAuthorized && <Alert type="error">We can’t access new reviews for this location.</Alert>}
      <p>
        <strong>{locationName}</strong><br/>
        {address}
      </p>
      <MapsLink {...{ googleLocation }}/>
    </div>
  );
}


export function VerifyLocationButton({ businessID, googleLocation }) {
  const isVerified = getGoogleLocationIsVerified(googleLocation);

  if (isVerified)
    return null;

  const isServiceArea = isServiceAreaLocation(googleLocation);

  const href = (
    isServiceArea ?
      `/${businessID}/settings/business_profile/google/address` :
      `/${businessID}/settings/business_profile/google/verify`
  );

  return (
    <p className="buttons-row">
      <a href={href} className="button button-fill verify-button">Verify this location</a>
    </p>
  );
}


function ReconnectLocationButton({ businessID }) {
  const href = `/${businessID}/settings/business_profile/google/connect`;

  return (
    <p className="buttons-row">
      <a href={href} className="button button-fill">Reconnect this location</a>
    </p>
  );
}


function DisconnectLocationButton({ googleLocation, disconnectLocation }) {
  const { locationName } = googleLocation;

  return (
    <ConfirmButton {...{
      label:             'Disconnect this location',
      className:         'disconnect-button',
      onConfirm:         disconnectLocation,
      confirmTitle:      'Disconnect Location',
      confirmSubtitle:   `Are you sure you want to disconnect ${locationName}?`,
      confirmButtonText: 'Disconnect'
    }}/>
  );
}


function MapsLink({ googleLocation }) {
  const mapsURL = getGoogleMapsURL(googleLocation);
  if (!mapsURL)
    return null;

  return (
    <p>
      <Link href={mapsURL} external>
        <i className="f7-icons">exit</i>
        View on Google Maps
      </Link>
    </p>
  );
}


function getGoogleMapsURL(googleLocation) {
  return googleLocation?.metadata?.mapsUrl;
}
